import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { CYBER_SECURITY_CAPABILITIES_PT } from '../constants/serviceCapabilitiesCyberSecurity'
import { SERVICE_ONE_TEAM_APPLICATION_PT } from '../constants/serviceOneTeamContent'
import { createServiceOtherSolutionsPt } from '../constants/serviceOtherSolutionsContent'
import { SERVICE_HERO_ASSETS, SERVICE_PAGE_PILLAR_ICONS } from '../constants/serviceHeroAssets'

const CibersegurancaPagePt = () => (
  <Layout lang="pt" title="Cibersegurança" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Serviços"
        title={'Cibersegurança.'}
        description={
          'Protegemos os seus sistemas com estratégias de segurança proativas, monitorização contínua e soluções orientadas à conformidade.'
        }
        heroImage={SERVICE_HERO_ASSETS.security.src}
        imageAlt="Ilustração de cibersegurança"
        imageWidth={SERVICE_HERO_ASSETS.security.width}
        imageHeight={SERVICE_HERO_ASSETS.security.height}
        pillarIcon={SERVICE_PAGE_PILLAR_ICONS.security.src}
        pillarIconWidth={SERVICE_PAGE_PILLAR_ICONS.security.width}
      />
      <ServiceCapabilities
        idBase="service-capabilities-cyber-security"
        sectionTitle="Capacidades criadas para Segurança & Confiança."
        tabs={CYBER_SECURITY_CAPABILITIES_PT}
        contactCtaIsEn={false}
      />
      <HomeTwo lang="pt" />
      <ServiceOneTeam
        idBase="service-one-team-cyber-security"
        {...SERVICE_ONE_TEAM_APPLICATION_PT}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-cyber-security"
        {...createServiceOtherSolutionsPt('cyber')}
      />
    </div>
  </Layout>
)

export default CibersegurancaPagePt
